import cx from 'classnames'
import Styles from './Row.module.scss'

import { RowProps } from './Types'

const Row = ({ children, className, size = 'md' }: RowProps) => {
  return <div className={cx(Styles.tr, className, Styles[size])}>{children}</div>
}

export { Row }
